import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import API from 'config/ApiConfig';
import { Mosaic } from "react-loading-indicators";

export default function UpdateSiswa() {
  const [formData, setFormData] = useState({
    nama: '',
    ttl: '',
    telepon: '',
    nama_orangtua: '',
    nama_sekolah: '',
    kelas: '',
    alamat: '',
    tentor_id: [], // Ubah menjadi array
    user_id: '',
  });
  const [tentors, setTentors] = useState([]);
  const [users, setUsers] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { siswaId } = useParams();
  const API_BASE_URL = API.API_ADMIN;
  const JWT_TOKEN = localStorage.getItem('authToken');

  function getAuthHeaders() {
    return {
      'Authorization': `Bearer ${JWT_TOKEN}`,
      'Content-Type': 'application/json',
    };
  }

  useEffect(() => {
    const fetchTentors = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/tentor`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setTentors(data);
      } catch (error) {
        console.error('Error fetching tentors:', error);
        setFetchError('Failed to fetch tentors.');
      }
    };

    const fetchUsers = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/user`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error('Error fetching users:', error);
        setFetchError('Failed to fetch users.');
      }
    };

    const fetchSiswaData = async () => {
      if (!siswaId) return;

      try {
        const response = await fetch(`${API_BASE_URL}/siswa/${siswaId}`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setFormData(data);
      } catch (error) {
        console.error('Error fetching siswa details:', error);
        setFetchError('Failed to fetch siswa details.');
      } finally {
        setLoading(false);
      }
    };

    fetchTentors();
    fetchUsers();
    fetchSiswaData();
  }, [siswaId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleTentorChange = (index, e) => {
    const { value } = e.target;
    setFormData((prevFormData) => {
      const newTentorIds = [...prevFormData.tentor_id];
      newTentorIds[index] = value;
      return {
        ...prevFormData,
        tentor_id: newTentorIds,
      };
    });
  };

  const handleAddTentorField = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      tentor_id: [...prevFormData.tentor_id, ''],
    }));
  };

  const handleRemoveTentorField = (index) => {
    setFormData((prevFormData) => {
      const newTentorIds = prevFormData.tentor_id.filter((_, i) => i !== index);
      return {
        ...prevFormData,
        tentor_id: newTentorIds,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_BASE_URL}/siswa/${siswaId}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      alert('Berhasil Memperbarui Siswa');
      window.location.href = '/admin/siswa';
    } catch (error) {
      console.error('Error updating siswa:', error);
      setFetchError('Failed to update siswa.');
    }
  };

  if (loading) {
    return <div className="flex m-4 justiy-content-center align-items-center"><Mosaic color="#1177bc" size="large" text="Loading" textColor="" /></div>
  }

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Update Siswa</h3>
      {fetchError && <p className="text-red-500 text-xs">{fetchError}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Input fields */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Nama:</label>
          <input
            type="text"
            name="nama"
            value={formData.nama}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Tempat Tanggal Lahir:</label>
          <input
            type="text"
            name="ttl"
            value={formData.ttl}
            onChange={handleChange}
            placeholder="misal Jakarta, 15 Januari 2008"
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Nomor Telepon:</label>
          <input
            type="text"
            name="telepon"
            value={formData.telepon}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Nama Orang Tua:</label>
          <input
            type="text"
            name="nama_orangtua"
            value={formData.nama_orangtua}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Nama Sekolah:</label>
          <input
            type="text"
            name="nama_sekolah"
            value={formData.nama_sekolah}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Kelas:</label>
          <input
            type="text"
            name="kelas"
            value={formData.kelas}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Alamat:</label>
          <input
            type="text"
            name="alamat"
            value={formData.alamat}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>

        {/* Tentor Dropdowns */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Pilih Tentor:</label>
          {formData.tentor_id.map((tentorId, index) => (
            <div key={index} className="flex items-center mb-2">
              <select
                name={`tentor_id_${index}`}
                value={tentorId}
                onChange={(e) => handleTentorChange(index, e)}
                className="w-full px-3 py-2 border border-blueGray-300 rounded"
              >
                <option value="">Pilih Tentor</option>
                {tentors.map((tentor) => (
                  <option key={tentor._id} value={tentor._id}>
                    {tentor.nama}
                  </option>
                ))}
              </select>
              <button
                type="button"
                onClick={() => handleRemoveTentorField(index)}
                className="ml-2 bg-red-500 text-white px-3 py-1 rounded"
              >
                Remove
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={handleAddTentorField}
            className="bg-lightBlue-500 text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
          >
            Add Tentor
          </button>
        </div>

        {/* User Dropdown */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Pilih User:</label>
          <select
            name="user_id"
            value={formData.user_id}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          >
            <option value="">Pilih User</option>
            {users.map((user) => (
              <option key={user._id} value={user._id}>
                {user.username}
              </option>
            ))}
          </select>
        </div>
        
        <div>
          <button
            type="submit"
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
          >
            Update Siswa
          </button>
          <a href="/admin/siswa">
            <button
              type="button"
              className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            >
              Cancel
            </button>
          </a>
        </div>
      </form>
    </div>
  );
}
